import { TextInput, type UseFormReturn } from '@faceup/form'
import { defineMessages, useIntl } from '@faceup/localization'

const messages = defineMessages('followUp.pages.createReport.components.aFClassroomField', [
  { id: 'classRoomLabel', defaultMessage: '' },
] as const)

type ClassroomItem = {
  id: string
  isRequired?: boolean
  labelTranslation?: { translation?: string | null } | null
  hintTranslation?: { translation?: string | null } | null
}

type Props = {
  form: UseFormReturn
  classroomItem: ClassroomItem
}

export const AF_ClassroomField = ({ form, classroomItem }: Props) => {
  const { formatMessage } = useIntl()

  const label =
    classroomItem.labelTranslation?.translation ?? formatMessage(messages.classRoomLabel)
  const hint = classroomItem.hintTranslation?.translation ?? undefined

  return (
    <TextInput
      control={form.control}
      name={`${classroomItem.id}.value`}
      label={label}
      hint={hint}
      withAsterisk={classroomItem.isRequired}
      autoComplete='off'
      data-test='create-company-report-form-class-room-input'
      formItemProps={{
        'data-test': 'create-company-report-form-class-room',
      }}
    />
  )
}
